// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "高等数学（一）",
      "tec": "马婷婷",
      "week": "6-17周",
      "add": "教学楼D座418教务处"
    },
    [
      {
        "sub": "工程计算系统",
        "tec": "范彬",
        "week": "6-9,17周",
        "add": "实训楼C座318"
      },
      {
        "sub": "工程计算系统",
        "tec": "范彬",
        "week": "10-16周",
        "add": "教学楼C座214教务"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[05-06节]）"
    },
    {
      "sub": "英语听说（一）",
      "tec": "外聘5",
      "week": "6-10周",
      "add": "207国教"
    },
    {
      "sub": "形势与政策",
      "tec": "祝嘉悦",
      "week": "6,8-10周",
      "add": "教学楼C座215教务"
    }
  ],
  "2": [
    {
      "sub": "高等数学（一）",
      "tec": "马婷婷",
      "week": "6-17周",
      "add": "教学楼D座418教务处"
    },
    {
      "sub": "大学英语（一）",
      "tec": "张育智",
      "week": "6-17周",
      "add": "207国教"
    },
    [
      {
        "sub": "工程基础",
        "tec": "周文婷",
        "week": "6-8周",
        "add": "教学楼A座416机械机房"
      },
      {
        "sub": "工程基础",
        "tec": "周文婷",
        "week": "9-16周",
        "add": "教学楼C座214教务"
      }
    ],
    {
      "sub": "大学物理",
      "tec": "赵明明",
      "week": "10-17周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "军事理论",
      "tec": "于瑶",
      "week": "6-13,15周",
      "add": "教学楼C座214教务"
    }
  ],
  "3": [
    {
      "sub": "大学物理",
      "tec": "赵明明",
      "week": "6-17周",
      "add": "教学楼C座309教务"
    },
    [
      {
        "sub": "工程计算系统",
        "tec": "范彬",
        "week": "6-9,17周",
        "add": "实训楼C座318"
      },
      {
        "sub": "工程计算系统",
        "tec": "范彬",
        "week": "10-16周",
        "add": "实训楼C座318"
      }
    ],
    0,
    [
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "6-11周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "12周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "12周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "13周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "13周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "14周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "14周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "15周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "15周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "16周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "16周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "17周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "17周",
        "add": "教学楼C座210教务"
      }
    ],
    0
  ],
  "4": [
    [
      {
        "sub": "工程计算系统",
        "tec": "范彬",
        "week": "6-9,17周",
        "add": "实训楼C座318"
      },
      {
        "sub": "工程计算系统",
        "tec": "范彬",
        "week": "10-16周",
        "add": "实训楼C座318"
      }
    ],
    {
      "sub": "大学英语（一）",
      "tec": "张育智",
      "week": "6-17周",
      "add": "教学楼D座228经管"
    },
    {
      "sub": "心理健康与调适",
      "tec": "王艳峰",
      "week": "6-15周",
      "add": "教学楼C座212教务"
    },
    [
      {
        "sub": "工程基础",
        "tec": "周文婷",
        "week": "6-8周",
        "add": "教学楼A座416机械机房"
      },
      {
        "sub": "工程基础",
        "tec": "周文婷",
        "week": "9-16周",
        "add": "教学楼A座416机械机房"
      }
    ],
    [
      {
        "sub": "工程基础",
        "tec": "周文婷",
        "week": "6-8周",
        "add": "教学楼A座416机械机房"
      },
      {
        "sub": "工程基础",
        "tec": "周文婷",
        "week": "9-16周",
        "add": "教学楼A座416机械机房"
      }
    ]
  ],
  "5": [
    {
      "sub": "工程基础",
      "tec": "周文婷",
      "week": "6-8周",
      "add": "教学楼A座416机械机房"
    },
    {
      "sub": "大学物理",
      "tec": "赵明明",
      "week": "6-17周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "高等数学（一）",
      "tec": "马婷婷",
      "week": "6-17周",
      "add": "教学楼D座418教务处"
    },
    [
      {
        "sub": "就业创业指导",
        "tec": "赵传钰",
        "week": "6-10周",
        "add": "教学楼C座214教务"
      },
      {
        "sub": "英语听说（一）",
        "tec": "外聘5",
        "week": "11-17周",
        "add": "207国教"
      }
    ],
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
